<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'

// emits
const emit = defineEmits(['handleDocAction', 'handleSelectItem']);

//props
interface Props {
  title?: string,
  subTitle?: string
}
const props = withDefaults(defineProps<Props>(), {
  title: '',
  subTitle: '',
})

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

</script>

<template>
    <div class="search-result search-result--empty">
      <div class="title">{{ title }}</div>
      <div class="subtitle">{{ subTitle }}</div>
      <img src="@/assets/img/search-empty.svg"/>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>